export default function TrustSection() {
  const trustItems = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Sellers',
      description: 'Every seller in our spreadsheet undergoes community verification to ensure authenticity and reliability.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20verification%20checklist%20and%20stamp%20on%20warm%20cream%20desk%20with%20various%20fashion%20product%20tags%20and%20labels%20scattered%20around%20soft%20natural%20window%20light%20from%20left%20side%20minimal%20depth%20of%20field%20focusing%20on%20verification%20concept%20warm%20beige%20tones%20editorial%20product%20photography&width=800&height=600&seq=trust-v2-verified&orientation=landscape',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Updated Daily',
      description: 'Our spreadsheet is maintained daily with the latest products, prices, and seller availability.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20fashion%20arrivals%20including%20folded%20hoodies%20and%20boxed%20sneakers%20on%20clean%20cream%20surface%20with%20digital%20tablet%20showing%20calendar%20and%20refresh%20icon%20soft%20morning%20sunlight%20streaming%20through%20window%20clean%20organized%20composition%20warm%20neutral%20palette%20editorial%20lifestyle%20photography&width=800&height=600&seq=trust-v2-updated&orientation=landscape',
    },
    {
      icon: 'ri-global-line',
      title: 'International Shipping',
      description: 'Products ship worldwide with detailed tracking information and delivery estimates.',
      imageUrl: 'https://readdy.ai/api/search-image?query=World%20map%20and%20shipping%20boxes%20with%20fashion%20accessories%20packed%20neatly%20on%20warm%20cream%20desk%20surface%20passport%20and%20tracking%20labels%20nearby%20soft%20natural%20overhead%20lighting%20global%20commerce%20concept%20minimalist%20editorial%20photography%20with%20travel%20friendly%20aesthetic&width=800&height=600&seq=trust-v2-shipping&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-4">Why Trust Us</p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">What Makes Our Spreadsheet Different</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            The AllChinaBuy Spreadsheet is a curated database of trusted products, verified sellers, and organized shopping links.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {trustItems.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all duration-300">
              <div className="h-48 overflow-hidden">
                <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className={`${item.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}